<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <!-- <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="app简称">
              <a-input placeholder="请输入app简称" v-model="queryParam.appAlias"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="banner名称">
              <a-input placeholder="请输入banner名称" v-model="queryParam.bannerName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="跳转页面类型">
              <j-dict-select-tag dictCode="app_banner_url_type" placeholder="请选择跳转页面类型" v-model="queryParam.urlType" />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="是否启用">
              <j-multi-select-tag
                :options="[
                  {
                    label: '是',
                    value: '1'
                  },
                  {
                    label: '否',
                    value: '0'
                  }
                ]"
                @change="searchQuery"
                type="checkbox"
                v-model="queryParam.enabled"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('app轮播图设置')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <app-banner-modal @ok="modalFormOk" ref="modalForm"></app-banner-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AppBannerModal from './modules/AppBannerModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'AppBannerList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      AppBannerModal
    },
    data () {
      return {
        description: 'app轮播图设置管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          //   {
          //     title: 'app简称',
          //     align: "center",
          //     sorter: true,
          //     dataIndex: 'appAlias'
          //   },
          {
            title: 'banner名称',
            align: "center",
            sorter: true,
            dataIndex: 'bannerName'
          },
          {
            title: 'banner位置',
            align: "center",
            sorter: true,
            dataIndex: 'position'
          },
          {
            title: '顺序',
            align: "center",
            sorter: true,
            dataIndex: 'sortNo'
          },
          {
            title: '图片',
            align: "center",
            sorter: true,
            dataIndex: 'picture',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '标题',
            align: "center",
            sorter: true,
            dataIndex: 'title'
          },
          {
            title: '跳转页面类型',
            align: "center",
            sorter: true,
            dataIndex: 'urlType_dictText'
          },
          {
            title: '跳转url',
            align: "center",
            sorter: true,
            dataIndex: 'url'
          },
          {
            title: '是否启用',
            align: "center",
            sorter: true,
            dataIndex: 'enabled',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['enabled'], text) : ''),
          },
          {
            title: '生效时间',
            align: "center",
            sorter: true,
            dataIndex: 'effectTime'
          },
          {
            title: '失效时间',
            align: "center",
            sorter: true,
            dataIndex: 'expireTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/custom/appBanner/list",
          delete: "/custom/appBanner/delete",
          deleteBatch: "/custom/appBanner/deleteBatch",
          exportXlsUrl: "/custom/appBanner/exportXls",
          importExcelUrl: "custom/appBanner/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.$set(this.dictOptions, 'enabled', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'appAlias', text: 'app简称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'bannerName', text: 'banner名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'position', text: 'banner位置', dictCode: '' })
        fieldList.push({ type: 'int', value: 'sortNo', text: '顺序', dictCode: '' })
        fieldList.push({ type: 'string', value: 'picture', text: '图片', dictCode: '' })
        fieldList.push({ type: 'string', value: 'urlType', text: '跳转页面类型', dictCode: 'app_banner_url_type' })
        fieldList.push({ type: 'string', value: 'url', text: '跳转url', dictCode: '' })
        fieldList.push({ type: 'switch', value: 'enabled', text: '是否启用' })
        fieldList.push({ type: 'datetime', value: 'effectTime', text: '生效时间' })
        fieldList.push({ type: 'datetime', value: 'expireTime', text: '失效时间' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>